
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Lag_1","data-name":"Lag 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 200 200"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"cls-1",attrs:{"d":"M156.138 106.576h-112.3a5.5 5.5 0 010-11h112.3a5.5 5.5 0 010 11z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M99.988 162.725a5.5 5.5 0 01-5.5-5.5V44.926a5.5 5.5 0 0111 0v112.3a5.5 5.5 0 01-5.5 5.5z"}})])
          )
        }
      }
    